var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.521 2.15a6.857 6.857 0 0 1-1.899.519c.69-.432 1.209-1.036 1.381-1.813-.604.346-1.294.69-2.071.777C12.81.338 10.738.253 9.444 1.374l-.173.173a3.335 3.335 0 0 0-.95 2.33c0 .259 0 .518.087.777-1.294-.086-2.589-.432-3.71-1.036a9.08 9.08 0 0 1-2.935-2.503c-.605 1.036-.605 2.244-.087 3.28.26.518.604.863 1.036 1.208-.518 0-1.036-.172-1.467-.431 0 .776.259 1.553.777 2.157.431.604 1.122 1.036 1.812 1.122-.259.087-.604.087-.863.087-.173 0-.432 0-.604-.087.172.69.604 1.209 1.122 1.64.518.432 1.208.69 1.899.69a6.1 6.1 0 0 1-3.97 1.468H.64c1.467.95 3.193 1.553 4.92 1.467 1.121 0 2.157-.173 3.192-.604a7.97 7.97 0 0 0 2.59-1.554c.69-.604 1.294-1.38 1.812-2.157 1.036-1.554 1.554-3.366 1.554-5.265v-.432c.863-.258 1.38-.863 1.812-1.553Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cefbff719ccf0677aae1d7f9d8e1afcc.svg";
export { ForwardRef as ReactComponent };